import { render, staticRenderFns } from "./TradeReportList.vue?vue&type=template&id=04863602&scoped=true&"
import script from "./TradeReportList.vue?vue&type=script&lang=js&"
export * from "./TradeReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04863602",
  null
  
)

export default component.exports